import { render, staticRenderFns } from "./ClaimReceptions.vue?vue&type=template&id=549317a8&scoped=true&"
import script from "./ClaimReceptions.vue?vue&type=script&lang=js&"
export * from "./ClaimReceptions.vue?vue&type=script&lang=js&"
import style0 from "./ClaimReceptions.vue?vue&type=style&index=0&id=549317a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549317a8",
  null
  
)

export default component.exports